import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FrownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const AccessDenied = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div style={{ display: 'flex', height: '100vh', marginTop:"5%", alignItems: 'center', justifyContent: 'center' }}>
            <Result
                icon={<FrownOutlined style={{ color: '#ff4d4f' }} />}
                status="403"
                title={t('accessDenied.title')}
                subTitle={t('accessDenied.subTitle')}
                description={t('accessDenied.description')}

                style={{
                    background: '#fff',
                    padding: '40px',
                    borderRadius: '12px',
                    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)',
                }}
            />
        </div>
    );
};

export default AccessDenied;






